import React, { useState, useEffect, useContext, useCallback } from 'react';
import "./NavBar.css";
import { useNavigate } from 'react-router-dom';
import { Packs } from '../Context/PacksContext';
import { UserInfo } from "../Context/UserInfoContext";
import { MedicalContext } from '../Context/MedicalContext';
import { jwtDecode}  from 'jwt-decode';
import Searcher from './Searcher';

function NavBar() {
  const Navigate = useNavigate();

  const [OrderChange, setOrderChange] = useState(true);

  const {
    BasketPacks, ExamsPerProduct, Purchased, SetPurchased, SetAdded
  } = useContext(Packs);

  const { setLoggedIn, LoggedIn, LoggedOut, setLoggedOut, setSessionExpired
  } = useContext(UserInfo);

  const {
    RelatedExams
  } = useContext(MedicalContext);

  let plusOne = RelatedExams.length !== 0 ? 1 : 0

  const PricingOfBasket = useCallback(() => {
    let payment = 0
      for(let i = 0; i<BasketPacks.length; i++) {
        payment += ExamsPerProduct[BasketPacks[i]].price
      }
    
      if(RelatedExams.length !== 0) {
        payment += 990
      }
      
      return payment
  },[BasketPacks,ExamsPerProduct,RelatedExams])

  const CurrentBasket = BasketPacks.length + plusOne;
  const [LowerBlock, setLowerBlock] = useState(window.innerWidth <= 950 ? true : false);
  const [BurgerMenu, setBurgerMenu] = useState(false);
  const [numberOfBlocks, setNumberOfBlocks] = useState(BasketPacks.length);
  const [PriceTotal, setPriceTotal] = useState(PricingOfBasket());
  const [BurgerSpecific, setBurgerSpecific] = useState(window.innerWidth <= 950 ? true : false);

  useEffect(() => {
    if(BasketPacks.length + plusOne !== CurrentBasket && OrderChange && Purchased && !document.URL.includes("orden-medica") && !document.URL.includes("mi-orden-medica")) {
      SetPurchased(false)
      setOrderChange(false)
      SetAdded(false)
    }
  },[BasketPacks, CurrentBasket,OrderChange,Purchased,SetPurchased,plusOne,SetAdded])

  useEffect(() => {
    const faceArray = ["https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"]
    //preloading image
    faceArray.forEach((face) => {
      const img = new Image();
      img.src = face;
    });
  }, []);

  useEffect(() => {
    if(LoggedIn) {
      if (sessionStorage.getItem('token')) {
        const token = sessionStorage.getItem('token');
        if (isTokenExpired(token)) {
          sessionStorage.removeItem('token');
          setSessionExpired(true)
          setLoggedIn(false)
          setLoggedOut(true)
        } 
      } else {
        setLoggedIn(false)
        setLoggedOut(true)
      }
    }
    
    if(!LoggedIn && document.URL.includes("encuesta-bienvenida")) {
      Navigate('/')
    }

    if(LoggedOut) {
      Navigate('/iniciar-sesion');
    }

    if(numberOfBlocks !== BasketPacks.length ) {
      setPriceTotal(PricingOfBasket())
      setNumberOfBlocks(BasketPacks.length)
    }
  },[LoggedIn,setLoggedIn,LoggedOut,setLoggedOut,numberOfBlocks,BasketPacks,setSessionExpired,Navigate,PricingOfBasket]);

  const isTokenExpired = (token) => {
    if (!token) return true;
    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      //console.log(decodedToken)
      return decodedToken.exp < currentTime;
    } catch (error) {
      console.error('Error decoding token:', error);
      return true;
    }
  };

  function ToggleNavbarDisplay() {
    let x = document.getElementById("NavbarBurgerIcon")
    x.classList.toggle("change");
    if(BurgerMenu) {
      setBurgerMenu(false)
    } else {
      setBurgerMenu(true)
    }
  }

  const HandleLowerBlock = useCallback(() => {
    if(window.innerWidth <= 950) {
      setLowerBlock(true)
      setBurgerSpecific(true)
    } else {
      setLowerBlock(false)
      setBurgerSpecific(false)
      setBurgerMenu(false)
    }
  },[])

  const hideUpperBar = useCallback(() => {
    let currentScrollPos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (!currentScrollPos) {
      document.getElementById("navbar").style.top = "0";
    } else {
      document.getElementById("navbar").style.top = "-30px";
    }
  },[])

  function numberWithCommas(x) {
    var parts = x.toString().split(".");
    parts[0]=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,".");
    return parts.join(",");
  }

  useEffect(() => {
    window.addEventListener("resize", HandleLowerBlock);
    return () => window.removeEventListener("resize", HandleLowerBlock);
  }, [HandleLowerBlock]);

  useEffect(() => {
    window.addEventListener("scroll", hideUpperBar);
    return () => window.removeEventListener("scroll", hideUpperBar);
  }, [hideUpperBar]);

  return (
    <div className='NavbarFull' id="navbar">
      <div className='NavbarPurpleUpBar'>
        <div className='NavbarPurpleUpBarInner'>
        <a  href='https://salud.yomecontrolo.cl/'  target="_blank" style={{ textDecoration: 'none' }}>  <div className='NavbarPurpleUpBarInnerButton NavInnerSelected' /* onClick={() => Navigate("/")} */> Portal Paciente</div></a>
          <div className='NavbarPurpleUpBarInnerSocial'>
            <a href='https://www.instagram.com/yomecontrolo/' target="_blank" className="SocialIcon" rel="mainWebsite">
              <img src="https://static.yomecontrolo.cl/public/icons/social-instagram.png" alt="Instagram Icon" height={25} />
            </a>
            <a href='https://cl.linkedin.com/company/yomecontrolo' target="_blank" className="SocialIcon" rel="mainWebsite">
              <img src="https://static.yomecontrolo.cl/public/icons/social-linkedin.png" alt="LinkedIn Icon" height={22} />
            </a>
          </div>
        </div>
      </div>
      <div className="NavbarFullBackGradient">
      <div className={LowerBlock && BurgerMenu ? "NavbarFullInner NavbarMenuOpen" : "NavbarFullInner"}>
        <div className="NavbarFullInnerLeftSide">
          <img src="https://static.yomecontrolo.cl/public/icons/ymc_NavbarLogo_Vector.png" className="NavbarFullInnerLeftSideLogoYMC" alt="logo" onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/")}} />
        </div>
      {!document.URL.includes("encuesta-bienvenida") ?
        <div className="NavbarFullInnerMiddleButtons">
          <div className='NavbarFullInnerMiddleIndividualButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/")}}>Inicio</div>
          <div className='NavbarFullInnerMiddleIndividualButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/quienes-somos")}}>Nosotros</div>
          <div className='NavbarFullInnerMiddleIndividualButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/contacto")}}>Contacto</div>


        </div>
        : null}  
 {/*    <Searcher/>  */}
        <div className="NavbarFullInnerRightSide">
         
          <div className="NavbarFullInnerRightSideMedOrderButton" onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/orden-medica")}}> 
            <span className="NavbarBeginSession">Mis órdenes</span> 
            <span className="NavbarBeginSessionPrice">${numberWithCommas(PriceTotal)}</span> 
            <img src="https://static.yomecontrolo.cl/public/icons/WhiteExamIcon.png" className="NavbarFullInnerRightSideExamIcon" alt="exam" />
            <img src="https://static.yomecontrolo.cl/public/icons/WhiteCartIcon.png" className="NavbarFullInnerRightSideCartIcon" alt="cart" />
            {BasketPacks.length + plusOne === 0 ?
              null :
              <div className="NavbarFullInnerRightSideMedOrderNotification rounded-pill">{BasketPacks.length + plusOne}</div>
            }
          </div>
          {!document.URL.includes("encuesta-bienvenida") && BurgerSpecific ?
          <div className="NavbarFullInnerRightSideBurgerIcon" id="NavbarBurgerIcon" onClick={() => ToggleNavbarDisplay()}>
            <div className="NavbarBurgerIconBar3"></div>
            <div className="NavbarBurgerIconBar1"></div>
            <div className="NavbarBurgerIconBar2"></div>
          </div>
          : null}
        </div>
      </div>
      {LowerBlock && BurgerMenu ?
      <div className="NavbarLowerBlockOptions">
        <div className="NavbarLowerBlockOptionsWhiteBox">
          {!document.URL.includes("encuesta-bienvenida") ?
          <>
          <div className='NavbarLowerBlockOptionsIndividualButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/")}}>Inicio</div>
          <div className='NavbarLowerBlockOptionsIndividualButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/quienes-somos")}}>Nosotros</div>
          <div className='NavbarLowerBlockOptionsIndividualButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/contacto")}}>Contacto</div>

{/*           <div className='NavbarLowerBlockOptionsIndividualButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/calculadora-de-salud")}}>Calculadora De Salud</div>
          <div className='NavbarLowerBlockOptionsIndividualButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/quienes-somos")}}>Nosotros</div>

          <div className='NavbarLowerBlockOptionsIndividualButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; setBurgerMenu(false); Navigate("/contacto")}}>Contacto</div> */}
          </>
          : null}
          {/* 
          <div className='NavbarLowerBlockOptionsIndividualButton2' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; setBurgerMenu(false); Navigate("/")}}>
            <div className='NavbarLowerBlockOptionsIndividualButton2Text'>Portal Paciente &ensp;</div>
            <img className="NavbarLowerBlockOptionsIndividualButton2Image" src="https://static.yomecontrolo.cl/public/icons/PurpleProfileLaptopIcon.png" alt="profileBurgerMenu" />
          </div>*/}
        </div>
      </div>
      : null }
      </div>
    </div>
  );
}

export default NavBar;